import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { OrderDetailsSection } from './sections/OrderDetailsSection';
import { ProductDetailsSection } from './sections/ProductDetailsSection';
import { EntityTabLayout } from '../../layout/Workspace';

function OrderDetailsComponent(props) {
  const {item} = props;
  const intl = useIntl();
  const [activeTab, setActiveTab] = useState('order-details');

  useEffect( () => {
    return () => {
      store.dispatch(hideNotification());
    }
  }, []);

  // The former sequential layout mounted both sections. Keep that lifecycle
  // contract while the tabs only change which section is presented.
  const tabPanels = (
    <div className="order-detail-tab-panels">
      <div
        aria-hidden={activeTab !== 'order-details'}
        className="order-detail-tab-panel"
        hidden={activeTab !== 'order-details'}
      >
        <OrderDetailsSection item={item}/>
      </div>
      <div
        aria-hidden={activeTab !== 'product-details'}
        className="order-detail-tab-panel"
        hidden={activeTab !== 'product-details'}
      >
        <ProductDetailsSection item={item}/>
      </div>
    </div>
  );
  const tabs = [
    {
      id: 'order-details',
      label: <FormattedMessage id="fields.order_details"/>,
      content: tabPanels
    },
    {
      id: 'product-details',
      label: <FormattedMessage id="fields.product_details"/>,
      content: tabPanels
    }
  ];
  const orderLabel = `${intl.formatMessage({ id: 'pages.orderManagement.viewOrder.title' })}${
    item?.order_number ? `: ${item.order_number}` : ''
  }`;

  return (
    <EntityTabLayout
      activeTab={activeTab}
      ariaLabel={orderLabel}
      className="order-detail-layout"
      header={props.header}
      onTabChange={setActiveTab}
      tabs={tabs}
    />
  );
}

OrderDetailsComponent.defaultProps = {
  header: null
};

export { OrderDetailsComponent };
